import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { AppBar, Toolbar, Menu, MenuItem, IconButton, Typography, Tooltip, ListItemIcon, ListItemText } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Check from '@material-ui/icons/Check';
import TranslateIcon from '@material-ui/icons/Translate';
import { NavLink as RouterLink } from 'react-router-dom';
import Logo from './Logo'
import { changeLanguage } from '../utils'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  }

}));

const languages = [
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
]

const MainNavbar = (props) => {
  const {t} = useTranslation();
  const classes = useStyles()
  const navigate = useNavigate()

  const [auth, setAuth] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogin = () => {
    navigate('/login/');
    setAnchorEl(null); //para cerrar item
  }
  const handleRegister = () => {
    navigate('/register/');
    setAnchorEl(null); //para cerrar item
  }

/*** section language icon */
const [anchorElLang, setAnchorElLang] = useState(null)
  const [selectedLang, setSelectedLang] = useState(localStorage.getItem('i18nextLng') || 'es')
  const openLang = Boolean(anchorElLang)

  const handleOpenLangMenu = (event) => {
    setAnchorElLang(event.currentTarget)
  }

  const handleCloseLangMenu = () => {
    setAnchorElLang(null)
  }

  const handleSelectLanguage = (code) => {

    changeLanguage(code); /**function change language i18n */
    setSelectedLang(code)
    handleCloseLangMenu()
  }
/*** section language icon */

  return (
    <>
      <AppBar className={classes.contMainNav} sx={{ backgroundColor: '#fbfbfb', color: '#468def', boxShadow: 'none', top: '60px' }}>
        <Toolbar>
          
          <Typography variant="h6" className={classes.title}>
          <RouterLink to="/">
            <Logo />
          </RouterLink>
          </Typography>

         {/** section language */}

            <div>
              <Tooltip title="Select language">
              <IconButton
                onClick={handleOpenLangMenu}
                aria-label="Select language"
                aria-controls={openLang ? 'language-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openLang ? 'true' : undefined}
                color="inherit"
                sx={{backgroundColor: '#5F81FF', color: '#fff', padding: '3px', '&:hover': { backgroundColor: '#5F81FF', color: '#fff' } }}
              >
                <TranslateIcon />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorElLang}
              id="language-menu"
              open={openLang}
              onClose={handleCloseLangMenu}
              onClick={handleCloseLangMenu}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {languages.map((lang) => (
                <MenuItem
                  key={lang.code}
                  selected={selectedLang === lang.code}
                  onClick={() => handleSelectLanguage(lang.code)}
                >
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <Typography variant="body1">{lang.flag}</Typography>
                  </ListItemIcon>
                  <ListItemText>{lang.label}</ListItemText>
                  {selectedLang === lang.code && (
                    <ListItemIcon sx={{ minWidth: 'auto', ml: 2 }}>
                      <Check />
                    </ListItemIcon>
                  )}
                </MenuItem>
              ))}
            </Menu>
            </div>

         {/** section language */}

          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="primary"
            >
              <AccountCircle style={{ fontSize: '1.5em' }} />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              onClose={handleClose}

            >
              <MenuItem onClick={handleLogin} className={classes.textItemMenu}><Typography variant='h6'>{t('signIn')}</Typography></MenuItem>
              <MenuItem onClick={handleRegister}><Typography variant='h6'>{t('register')}</Typography></MenuItem>
            </Menu>
          </div>

        </Toolbar>
      </AppBar>
    </>

  )

}



export default MainNavbar;